/**
 * Created by Ning Jiang on 2021-05-18.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {IKarenGameData} from "../../game/server/data/IKarenData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {KarenGameConfig} from "../../game/KarenGameConfig";
import {Karen} from "../../game/Karen";
import {KarenParsedGameData} from "../../game/server/data/KarenParsedGameData";
import {KarenParsedInitData} from "../../game/server/data/KarenParsedInitData";
import {IWinRatioConfig} from "../config/WinRatio";

export class GameHelper {
    public static isFreeSpin(mode: GameMode): boolean {
        let isFS: boolean = true;
        if (mode == GameMode.NORMAL) {
            isFS = false;
        }
        return isFS;
    }

    public static isFreeSpinTrigger(mode: GameMode, nextMode: GameMode): boolean {
        let isFSTrigger: boolean = false;
        if (mode == GameMode.NORMAL && nextMode == GameMode.FREESPIN) {
            isFSTrigger = true;
        }
        return isFSTrigger;
    }

    public static getFSLevel(data: KarenParsedGameData | KarenParsedInitData): number {
        let level: number = 0;
        const sCount: number = data.scatterPositionsEnteringFreespin!.filter((value: number) => {
            return value > -1;
        }).length;
        if (sCount > 2) {
            level = sCount > 3 ? 1 : 0;
            if (data.doReelNudge) {
                level = sCount > 3 ? 3 : 2;
            }
        }
        return level;
    }

    //forIntro
    public static getSkinType(level: number): string {
        let skinType = "value";
        if (level == 1) {
            skinType = "deluxe";
        } else if (level == 2) {
            skinType = "value_and_purple";
        } else if (level == 3) {
            skinType = "deluxe_and_purple";
        }
        if(Karen.model.isRestore && !GameHelper.isFreeSpinTrigger(Karen.model.parsedInitData.mode,Karen.model.parsedInitData.nextMode)){
            skinType = "";
        }
        return skinType;
    }

    //#173 for Outro
    public static getWinRatioLevel(ratio: number): string {
        let skinType = "tire";
        if (ratio > 49) {
            skinType = "1star";
        }
        if (ratio > 99) {
            skinType = "2star";
        }
        if (ratio > 499) {
            skinType = "3star";
        }
        return skinType;
    }

    public static isXWaysPresent(data: KarenParsedGameData): boolean {
        const sCount: number = data!.scatterPositions!.filter((value: number) => {
            return value > -1;
        }).length;
        let sCountToBeConverted: boolean = false;
        const xWCount: number = data!.xWPositions!.filter((value: number) => {
            return value > -1;
        }).length;
        if (!GameHelper.isFreeSpin(data.mode)) {
            if (sCount > 0 && sCount < 3) {
                sCountToBeConverted = true;
            }
        }
        return ( sCountToBeConverted || ( xWCount > 0 ) || GameHelper.isInfectious(data) );
    }

    public static isInfectious(data: KarenParsedGameData): boolean {
        let isInfectious: boolean = false;
        const xWInPos: number = data.reels[0].indexOf("XW2");
        if (xWInPos === 1 || xWInPos === 2) {
            isInfectious = true;
        }
        return isInfectious;
    }

    public static createFalsyArray(rawData: IKarenGameData): boolean[][] {
        return ArrayHelper.initArrayWithValues(KarenGameConfig.REELS_NUM, (index: number) => ArrayHelper.initArrayWithValues(rawData.evaluatedArea[index].length, () => false));
    }

    public static createSingleArray(): boolean[] {
        return ArrayHelper.initArrayWithValues(KarenGameConfig.REELS_NUM, (index: number) => false);
    }

    public static isWinBelowStake(): boolean {
        return Karen.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && ( parseFloat(Karen.model.data.accumulatedRoundWin) <= this.getBuyFeaturePrice() );
    }

    public static getBuyFeaturePrice(): number {
        let betLevel = Karen.apiPlugin.freeBets.hasFreeBets() ? Karen.apiPlugin.freeBets.getBet() : Karen.apiPlugin.betLevel.getLevel();
        let price: number = parseFloat(Karen.model.gameData?.playedBetValue) || parseFloat(betLevel);
        if (Karen.model.data.wasFeatureBuy || (Karen.model.data && Karen.model.data.boostedBetPlayed)) {
            for (let index = 0; index < Karen.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Karen.model.initData.featureBuyTimesBetValue[index].name === Karen.model.buyFeatureName) {
                    price *= Karen.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

}